import template from './fee.jade';
import validation from './../../../services/validation';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular.module('cian.addForm.bargainFee', []).directive('cianAfPriceAndDealTermsFee', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    'adListenerService',
    'deviceService',
    'store',
    function (adListenerService, deviceService, store) {
      this.isMobile = deviceService.isMobile;
      if (!this.ad.bargainTerms) {
        this.ad.bargainTerms = {};
      }

      // Не для собственников. Если только собственник раньше уже не задавал ненулевые комиссии
      this.isFeeVisible = !this.ad.isByHomeowner || this.ad.bargainTerms.clientFee || this.ad.bargainTerms.agentFee;

      // Слушаем изменение формы
      adListenerService.$watch(
        () => this.ad.isByHomeowner,
        isByHomeowner => {
          this.isFeeVisible = !isByHomeowner || this.ad.bargainTerms.clientFee || this.ad.bargainTerms.agentFee;
        },
      );

      if (!this.ad.bargainTerms.clientFee) {
        const isSaved = typeof this.ad.bargainTerms.clientFee !== 'undefined';

        this.noClientFee = isSaved;
      }

      if (!this.ad.bargainTerms.agentFee) {
        const isSaved = typeof this.ad.bargainTerms.agentFee !== 'undefined';

        this.noAgentFee = isSaved;
      }

      this.noClientFeeChanged = () => {
        if (this.noClientFee) {
          this.ad.bargainTerms.clientFee = undefined;
          this.form['bargainTerms.clientFee'].$setUntouched();
        }
      };

      this.noAgentFeeChanged = () => {
        if (this.noAgentFee) {
          this.ad.bargainTerms.agentFee = undefined;
          this.form['bargainTerms.agentFee'].$setUntouched();
        }
      };

      this.validationClient = validation(this.form, 'bargainTerms.clientFee', {
        parse: 'Введите число',
        required: 'Укажите процент от прямого клиента',
        min: 'Значение не может быть отрицательным',
        max: 'Процент должен быть меньше или равен 100%',
      });

      this.validationAgent = validation(this.form, 'bargainTerms.agentFee', {
        parse: 'Введите число',
        required: 'Укажите комиссию для агентов',
        min: 'Значение не может быть отрицательным',
        max: 'Процент должен быть меньше или равен 100%',
      });

      let trackedValue;

      this.handleBlur = () => {
        const value = this.ad.bargainTerms.clientFee;

        if (value && value !== trackedValue) {
          const state = store.getState();
          const category = selectAnalyticsOfferStatus(state);

          trackRequiredFieldFill(category, 'сommission_from_customer');
          trackedValue = value;
        }
      };
    },
  ],
  controllerAs: 'fee',
  template,
})).name;
